import React, { useEffect, useState } from 'react';
import OpportunitiesWelcomeBanner from './OpportunitiesWelcomeBanner';
import OpportunitiesToolsGrid from './OpportunitiesToolsGrid';
import ExploreCarousel from '../Succession/Home/ExploreCarousel';
import PartnerMiniGrid from '../Succession/PartnerMiniGrid';
import SellerHeatMap from '../Succession/SellerHeatMap';
import PartialSalesMiniList from '../Succession/PartialSales/PartialSalesMiniList';
import RolodexMiniCard from '../Succession/RolodexMiniCard';
import { SnackbarProvider } from 'notistack';
import SuccessionThemeProvider from '../Succession/SuccessionThemeProvider';
import SuccessionDrawerWithListener from '../../containers/Succession/SuccessionDrawerWithListener';

const OpportunitiesExplorerContent = ({ current_user, company }) => {
  const items = [
    (
      <div className="bg-succession-bg-primary overflow-hidden shadow-succession-md rounded-lg h-full transition-all duration-300">
        <div className="px-4 py-5 sm:p-6 h-full flex flex-col">
          <PartnerMiniGrid />
        </div>
      </div>
    ),
    (<RolodexMiniCard />),
    (<SellerHeatMap />),
    (
      <div className="bg-succession-bg-primary overflow-hidden shadow-succession-md rounded-lg h-full transition-all duration-300">
        <div className="px-4 py-5 sm:p-6 h-full flex flex-col">
          <PartialSalesMiniList />
        </div>
      </div>
    ),
    // Conditionally include HiringPostsTile when feature is enabled
    
  ];
  const [page, setPage] = useState(0);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1440);

  const getSlotsForWidth = (w) => {
    if (!w || typeof w !== 'number') return 4;
    if (w >= 1280) return 4; // xl and up
    if (w >= 1024) return 3; // lg
    if (w >= 768) return 2;  // md
    return 1;                // sm
  };

  useEffect(() => {
    const onResize = () => { try { setWindowWidth(window.innerWidth); } catch(_) {} };
    try { window.addEventListener('resize', onResize); } catch(_) {}
    return () => { try { window.removeEventListener('resize', onResize); } catch(_) {} };
  }, []);

  const effectivePageSize = Math.min(4, getSlotsForWidth(windowWidth));
  const totalPages = Math.max(1, Math.ceil(items.length / effectivePageSize));

  useEffect(() => { setPage((p) => Math.min(p, totalPages - 1)); }, [totalPages]);

  const handleNext = () => { if (page + 1 < totalPages) setPage(page + 1); };
  const handlePrev = () => { if (page > 0) setPage(page - 1); };
  return (
    <div className="bg-succession-bg-primary overflow-hidden shadow-succession-md rounded-lg">
      <div className="px-4 py-3 flex items-center">
        <h3 className="text-succession-text-primary m-0 p-0">Explore Opportunities</h3>
        {totalPages > 1 && (
          <div className="ml-auto flex items-center gap-2">
            <button
              className="px-2 py-1 rounded border border-succession-border text-succession-text-secondary hover:bg-white"
              onClick={handlePrev}
              aria-label="Previous"
            >
              ‹
            </button>
            <button
              className="px-2 py-1 rounded border border-succession-border text-succession-text-secondary hover:bg-white"
              onClick={handleNext}
              aria-label="Next"
            >
              ›
            </button>
          </div>
        )}
      </div>
      <div className="p-4">
        <ExploreCarousel items={items} page={page} pageSize={4} itemHeight={500} />
      </div>
    </div>
  );
};

const OpportunitiesCategoryPage = (props) => {
  const name = (props?.current_user && props.current_user.name) || (typeof document !== 'undefined' && document.store?.getState?.()?.user?.name) || 'there';
  return (
    <div className="p-4 text-succession-text-primary space-y-4 overflow-x-hidden max-w-[100vw]">
      <div>
        <OpportunitiesWelcomeBanner userName={name} />
      </div>
      <div>
        <OpportunitiesToolsGrid />
      </div>
      <div>
        <OpportunitiesExplorerContent current_user={props.current_user} company={props.company} />
      </div>
      <SnackbarProvider maxSnack={3}>
        <SuccessionThemeProvider company={props.company} user={props.current_user}>
          <SuccessionDrawerWithListener />
        </SuccessionThemeProvider>
      </SnackbarProvider>
    </div>
  );
};

export default OpportunitiesCategoryPage;


